<template>
  <div id="appointment-details" v-if="!loading">
    <header-vue
      :popup-add="showThePopupAdd"
      :popup="showThePopup"
      :edit-mode="editMode"
      :edit-level="editLevel"
      :display-search="displaySearch"
      :hide-search="hideSearch"
      :add-option="addOption"
      :hide-add-option="hideAddOption"
    />
    <section-vue
      :edit-mode="editMode"
      :edit-level="editLevel"
      :popup="showThePopupAdd"
      :first-click="firstClick"
      :set-edit-level="setEditLevel"
      :set-first-click="setFirstClick"
      :display-search="displaySearch"
      :show-search="showSearch"
      :hide-search="hideSearch"
      :add-option-selected="addOptionSelected"
    />
    <div class="popup" v-show="showPopup">
      <transition name="pop">
        <popup-vue
          v-if="showPopup"
          :cancel="cancel"
          :un-cancel="unCancel"
          :hide="hideThePopup"
        />
      </transition>
    </div>

    <div class="popup" v-show="showPopupAdd">
      <transition name="pop">
        <popup-add-vue
          :all="allEdit"
          v-if="showPopupAdd"
          :hide="hideThePopupAdd"
        />
      </transition>
    </div>
  </div>
  <div class="loader-container" v-else>
    <loader-vue />
  </div>
</template>

<script>
import HeaderVue from "./Header.vue";
import SectionVue from "./Section.vue";
import PopupVue from "./Popup.vue";
import PopupAddVue from "../AddAppointment/Popup";
import LoaderVue from "../common/Loader.vue";
import { authMixin } from "../../../mixins/authMixin.js";
import { addEditAppointmentHomeMixin } from "../../../mixins/addEditAppointmentHomeMixin";
import { appointmentDetailMixin } from "../../../mixins/appointmentDetailMixin";
import { mapGetters, mapMutations } from "vuex";

export default {
  mixins: [
    authMixin, // For authentication
    appointmentDetailMixin, // For appointment details
    addEditAppointmentHomeMixin // For edit appointment
  ],
  data() {
    return {
      showPopup: false,
      showPopupAdd: false,
      cancel: false,
      unCancel: false,
      allEdit: false,
      displaySearch: false,
      prevSearchVal: ""
    };
  },
  computed: {
    ...mapGetters({
      edit: "getEdit", // Get the edit details
      getAppointmentSubmitted: "getAppointmentSubmitted", // Check if appointent has been submitted and page can be changed
      loading: "getIsLoadingAddAppointment", // Should loading screen be shown
      previousRoute: "getPreviousRoute", // Previous route info
      searchValue: "getSearchValue" // Search value
    }),
    editMode() {
      return this.edit.editMode;
    },
    editLevel() {
      return this.edit.editLevel;
    },
    firstClick() {
      return this.edit.firstClick;
    }
  },
  methods: {
    ...mapMutations({
      setEditLevel: "setEditLevel",
      setEditMode: "setEditMode",
      setFirstClick: "setFirstClick",
      setSubmitted: "setSubmitted", // Set submitted to false when done
      restoreDefault: "restoreDefault", // Restoring form fields to their default values
      setChangeToEdit: "setChangeToEdit", // Set this to false to specify that this add appointment is not edit by default
      emptySearchAll: "emptySearchAll", // Clear search results if required
      setSearchValue: "setSearchValue" // Set search value
    }),
    ...mapMutations("addNew", {
      clearState: "clear"
    }),
    /**
     * Method for showing popop
     */
    showThePopup(deleteOrCancel) {
      this.showPopup = true;
      if (deleteOrCancel === "cancel") {
        this.cancel = true;
        this.unCancel = false;
      } else if (deleteOrCancel === "un-cancel") {
        this.unCancel = true;
        this.cancel = false;
      } else {
        this.cancel = false;
        this.unCancel = false;
      }
    },
    showThePopupAdd(all = false) {
      all = all === true;
      this.allEdit = all;
      this.showPopupAdd = true;
    },
    /**
     * Method for hiding popup
     */
    hideThePopup() {
      this.showPopup = false;
    },
    hideThePopupAdd() {
      this.showPopupAdd = false;
    },
    /**
     * Method to show the search
     */
    showSearch() {
      this.displaySearch = true;
    },
    hideSearch() {
      this.displaySearch = false;
    }
  },
  components: {
    HeaderVue,
    SectionVue,
    PopupVue,
    LoaderVue,
    PopupAddVue
  },
  watch: {
    /**
     * Check when ever appointment is deleted, then automatically return to daily (After getting the response)
     */
    getDeletedAppointment(value) {
      if (value === true) {
        if ("previousRoute" in this && this.previousRoute === "/") {
          this.$router.push("/daily");
          return;
        }
        this.$router.go(-1);
      }
    },
    /**
     * watching value of is submitted, to know when the form has been submitted and the route needs to change
     */
    getAppointmentSubmitted(value) {
      if (value && this.editLevel !== 1) {
        this.$router.push("/daily");
        this.setSubmitted(false);
      } else {
        this.setSubmitted(false);
        this.setEditLevel(2);
        this.clearState();
      }
    },
    /**
     * Check when edit can be loaded after everything has been set
     */
    getChangeToEdit(value) {
      if (value === true) {
        this.setEditMode(true);
      }
    },
    editLevel() {
      setTimeout(() => {
        this.hideThePopupAdd();
      });
    }
  },
  created() {
    this.prevSearchVal = this.searchValue;
  },
  beforeDestroy() {
    this.setSearchValue(this.prevSearchVal);
  },
  destroyed() {
    this.restoreDefault();
    this.setChangeToEdit(false);
    this.clearState();
    this.emptySearchAll();
  }
};
</script>

<style scoped>
.popup {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
}

/* stage 2. Entered */
.pop-enter-active {
  animation: pop-in 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.pop-leave-active {
  animation: pop-out 0.2s ease-in-out forwards;
}

@keyframes pop-in {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes pop-out {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(0);
    opacity: 0;
  }
}
</style>
